import React from 'react';
import { CountdownTimerSecondary } from '@components-library/CountdownTimer/CountdownTimerSecondary';
import cn from 'classnames';
import styles from './bonusPopup.module.scss';

export interface BonusPopupTimerProps {
  colorTheme?: 'inverted';
  expirationTime: string;
  className?: string;
  onClick?: () => void;
}

export const BonusPopupTimer = ({ expirationTime, colorTheme, className, onClick }: BonusPopupTimerProps) => {
  return (
    <CountdownTimerSecondary
      className={className}
      classes={{
        item: cn({ [styles.invertedThemeItem]: colorTheme === 'inverted' }),
        dots: cn({ [styles.invertedThemeDots]: colorTheme === 'inverted' }),
      }}
      units={['hours', 'minutes', 'seconds']}
      expirationTime={expirationTime}
      onClick={onClick}
    />
  );
};
